<template>

    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>Questionnaire <span v-if="customerId > 0">- {{customer.company}}</span></h1>
                <div class="pageOptions">
                    <btn text="Ajouter une question" ico="add" @click="addQuestion"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state !== '1' && isEdition"></btn>
                    <btn text="Aperçu" ico="eye" @click="preview"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state !== '1' && isEdition"></btn>
                    <btn text="Publier" ico="download" @click="published"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state !== '1' && isEdition"></btn>
                    <btn text="Enregistrer" ico="valide" @click="check"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit') && isEdition"></btn>
                    <btn text="Imprimer" ico="print" @click="print"
                         v-if="$store.getters.hasPerm('questionnaire:print')"></btn>
                    <btn ico="times" color="red" @click="cancel"
                         v-if="$store.getters.hasPerm('questionnaire:add/edit')"></btn>
                </div>
            </div>
        </div>
        <form>
            <div class="line">
                <div class="large">
                    <label for="label">Nom du questionnaire</label>
                    <input type="text" v-model="questionnaire.label" id="label">
                </div>
            </div>
            <div class="line">
                <div class="large" v-if="!hasCustomer">
                    <label for="label">Nom du client</label>
                    <model-list-select
                            :list="customers"
                            v-model="customer"
                            option-value="id"
                            option-text="company"
                            placeholder="Sélectionner un client">
                    </model-list-select>
                </div>
            </div>
<!--            <div class="line">-->
<!--                <div class="large">-->
<!--                    <label>Motif de l'appel</label>-->
<!--                    <model-list-select v-model="questionnaire.reason"-->
<!--                                       :list="reasons"-->
<!--                                       option-value="id"-->
<!--                                       option-text="label"-->
<!--                                       placeholder="Sélectionner un motif d'appel">-->

<!--                    </model-list-select>-->

<!--                </div>-->
<!--            </div>-->
            <div class="line" v-if="$store.getters.hasPerm('questionnaire:add/edit') && questionnaire.state !== '1' && isEdition">
                <div class="large">
                    <div class="checkbox ">
                        <input type="checkbox" v-model="conditionActive" id="conditionActive">
                        <label for="conditionActive">Afficher les conditions</label>
                    </div>
                </div>
            </div>
        </form>
        <Questions :questions="questions" :edit="isEdition" :conditionActive="conditionActive"></Questions>
    </div>

</template>

<script>

    import SearchBar from "@/components/SearchBar";
    import Pagination from "@/components/Pagination";
    import Loader from "@/components/Loader";
    import TableOrder from "@/components/TableOrder";
    import axios from 'axios';
    import tools from '../config.ts';
    import Btn from "@/components/Btn";
    import Questions from "@/components/questionnaire/Questions";
    import {ModelListSelect} from 'vue-search-select';

    export default {
        name: "Questionnaire",
        components: {Questions, Btn, Pagination, SearchBar, Loader, TableOrder, ModelListSelect},
        data() {
            return {
                questionnaireId: 0,
                questionnaire: {},

                questions: [],

                action: 'show',

                hasCustomer:false,
                customerId: 0,
                customer: {},
                customers: [],
                reasons: [],

                active: false,

                conditionActive: true,
            }
        },
        methods: {
            load() {

                if (!this.questionnaireId) {
                    tools.$emit('addQuestion');
                    tools.loader(false);
                    return;
                }

                axios.get(tools.api("questionnaire/" + this.questionnaireId), tools.headerGET())
                    .then((response) => {

                        this.questionnaire = response.data;
                        this.questionnaire.questions = JSON.parse(this.questionnaire.questions);

                        // FIX pattern empty
                        this.questionnaire.questions.map(question => {
                            if(!question.pattern){
                                let pattern = "";
                                question.conditions.forEach((condition,key) => {
                                    pattern += "condition_"+(key+1)+" ET "
                                });
                                pattern = pattern.substr(0,pattern.length - 4);
        
                                question.pattern = pattern
                            }
                            return question;
                        })
                        
                        this.questions = this.questionnaire.questions;
                        
                        if(response.data.customer.id && !this.hasCustomer){
                            this.customerId = response.data.customer.id
                            this.loadCustomer()
                        }
                        
                        tools.loader(false);
                        tools.saveLocals("questionnaire", this);
                        tools.$emit("updateQuestions")
                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            loadReasons() {

                axios.get(tools.api("reasons/customer/" + this.customerId), tools.headerGET())
                    .then((response) => {
                        this.reasons = response.data;

                        if (this.reasons.length <= 0) {
                            this.reasons.push({
                                id: 0,
                                label: "Il n'y a aucun motif d'appel"
                            })
                        }
                    })

            },
            loadCustomer() {

                axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                    .then((response) => {
                        this.customer = response.data;
                    })

            },
            loadCustomers() {

                axios.get(tools.api("customers"), tools.headerGET())
                    .then((response) => {
                        this.customers = response.data;
                    })
            },
            check() {

                if (this.questions.length > 0) {
                    this.questions[0].conditions = [];
                }

                // Check question empty
                let hasError = false;
                this.questions.map((question) => {
                    if (!question.label) {
                        hasError = true;
                    }
                });

                if (!hasError) {
                    return this.save("/customer/" + this.customerId + "/questionnaires");
                }

                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Des questions sont vides. Voulez-vous quand même enregistrer ?",
                    success: () => {
                        this.save("/customer/" + this.customerId + "/questionnaires");
                    },
                    error: () => {
                        this.active = false
                    }
                })

            },
            save(nextURL) {

                let questions = JSON.stringify(this.questions);

                // console.log(this.questions);

                let url = "questionnaire";
                if (this.questionnaireId) {
                    url += "/" + this.questionnaireId
                }

                let datas = {
                    customer_id: this.customerId,
                    // reason_id: this.questionnaire.reason.id || this.questionnaire.reason,
                    reason_id: 0,
                    label: this.questionnaire.label,
                    state: this.questionnaire.state || -1,
                    questions: questions,
                    active: this.active
                }

                axios.post(tools.api(url), tools.toPOST(datas), tools.headerPOST())
                    .then((response) => {
                        tools.loader(false);
                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'enregistrement du questionnaire",
                            });
                        }

                        this.$router.push(nextURL)
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement du questionnaire. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })

            },
            published() {
                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Voulez-vous vraiment publier ce questionnaire ?<br/>Il ne sera plus possible de le modifier par la suite.<br/>Les questionnaires rattachés au même client et motif d'appel seront désactivés",
                    success: () => {
                        this.questionnaire.state = 1;
                        this.active = true;
                        this.check();
                    }
                })
            },
            cancel() {

                if (!this.isEdition) {
                    return this.$router.back();
                }

                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Voulez-vous vraiment annuler les modifications ?",
                    success: () => {
                        this.$router.back()
                    }
                })
            },
            preview() {
        
                if (!this.questionnaireId) {
                    return tools.popup("valid", {
                        title: "Enregistrement",
                        message: "Vous devez enregistrer une première fois le questionnaire pour accéder à la preview",
                    })
                }
    
                this.save("/customer/" + this.customerId + "/questionnaire/" + this.questionnaireId + "/response/preview")
        
            },
            print() {
        
                if (!this.questionnaireId) {
                    return tools.popup("valid", {
                        title: "Enregistrement",
                        message: "Vous devez enregistrer une première fois le questionnaire pour accéder à l'impression",
                    })
                }
    
                this.$router.push("/customer/" + this.customerId + "/questionnaire/" + this.questionnaireId + "/response/print");
        
            },
            addQuestion() {
                tools.$emit('addQuestion');
            }

        },
        computed: {
            isEdition() {
                return this.action === 'edit';
            }
        },
        watch:{
            customer(){
                if(this.hasCustomer){
                    return;
                }

                this.customerId = this.customer.id;

                this.loadReasons()
            }
        },
        mounted() {

            if (!this.$store.getters.hasPerm('questionnaire:add/edit')) {
                return this.$router.back();
            }

            this.questionnaireId = this.$route.params.questionnaire_id;
            this.customerId = this.$route.params.customer_id;
            this.action = this.$route.params.action;

            if(this.customerId > 0){
                this.hasCustomer = true;
            }

            tools.setLocals("questionnaire", this);
            tools.setCookies("questionnaire", this);

            tools.loader(true);

            this.$store.commit("onEditMode", true);

            tools.$on("updateQuestions", (questions) => {

                if (questions) {
                    this.questions = questions;
                }
                // console.log(this.questions)
                this.$store.commit("updateQuestions", this.questions);
            });

            this.load();
            if(this.hasCustomer) {
                this.loadReasons();
                this.loadCustomer();
            }else{
                this.loadCustomers();
            }
        }
    }
</script>
